import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Credit = () => {
    const [credits, setCredits] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('add'); // 'add' or 'edit'
    const [formData, setFormData] = useState({ total_credits: '', id: null });

    // Fetch credit data from the API
    useEffect(() => {
        fetchCredits();
    }, []);

    const fetchCredits = () => {
        axios.get("https://palaceofriches.badskullgaming.com/api/get-credits")
            .then(response => {
                if (response.data && Array.isArray(response.data.credits)) {
                    setCredits(response.data.credits);
                } else {
                    setCredits([]);
                }
            })
            .catch(error => {
                console.error("Error fetching credit data:", error);
                toast.error("Failed to fetch credit data.");
            });
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle modal open
    const handleOpenModal = (type, credit = null) => {
        setModalType(type);
        if (type === 'edit' && credit) {
            setFormData({ total_credits: credit.total_credits, id: credit.id });
        } else {
            setFormData({ total_credits: '', id: null });
        }
        setShowModal(true);
    };

    // Handle modal close
    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (modalType === 'add') {
            axios.post("https://palaceofriches.badskullgaming.com/api/store-credits", {
                total_credits: formData.total_credits
            })
                .then(() => {
                    toast.success("Credit added successfully!");
                    fetchCredits(); // Refresh data
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error adding credit:", error);
                    toast.error("Failed to add credit.");
                });
        } else if (modalType === 'edit') {
            axios.put(`https://palaceofriches.badskullgaming.com/api/update-credits/${formData.id}`, {
                total_credits: formData.total_credits
            })
                .then(() => {
                    toast.success("Credit updated successfully!");
                    fetchCredits(); // Refresh data
                    handleCloseModal();
                })
                .catch(error => {
                    console.error("Error updating credit:", error);
                    toast.error("Failed to update credit.");
                });
        }
    };

    // Handle delete credit
    const handleDelete = (id) => {
        axios.delete(`https://palaceofriches.badskullgaming.com/api/deletecredits/${id}`)
            .then(() => {
                setCredits(credits.filter(credit => credit.id !== id));
                toast.success("Credit deleted successfully!");
            })
            .catch(error => {
                console.error("Error deleting credit:", error);
                toast.error("Failed to delete credit.");
            });
    };

    return (
        <>
            <div className="container">
                <div className="d-flex justify-content-between my-3">
                    <h2>Credit Data</h2>
                    <Button onClick={() => handleOpenModal('add')} style={{ backgroundColor: '#FE0000', borderColor: '#FE0000', color: 'var(--bs-white)' }} className="mb-3">Add Credit</Button>
                </div>

                {credits.length > 0 ? (
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Total Credits</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {credits.map((credit, index) => (
                                <tr key={credit.id}>
                                    <td>{index + 1}</td>
                                    <td>{credit.total_credits}</td>
                                    <td>{new Date(credit.created_at).toLocaleDateString()}</td>
                                    <td>
                                        <Button variant="danger" onClick={() => handleOpenModal('edit', credit)}>Edit</Button>{' '}
                                        <Button variant="danger" onClick={() => handleDelete(credit.id)}>Delete</Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>No credit data available.</p>
                )}
            </div>

            {/* Modal for Add/Edit Credit */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'add' ? 'Add Credit' : 'Edit Credit'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formTotalCredits">
                            <Form.Label>Total Credits</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter total credits"
                                name="total_credits"
                                value={formData.total_credits}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Button style={{ backgroundColor: '#FE0000', borderColor: '#FE0000', color: 'var(--bs-white)' }} type="submit" className="mt-3">
                            {modalType === 'add' ? 'Add Credit' : 'Update Credit'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Toast container */}
            <ToastContainer />
        </>
    );
};

export default Credit;
